import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Row } from 'reactstrap';

const OPlaceholder = () => {
    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <h5 className="card-title placeholder-glow">
                        <span className="placeholder col-6"></span>
                    </h5>
                    <p className="card-text placeholder-glow">
                        <span className="placeholder col-7"></span>
                        <span className="placeholder col-4"></span>
                        <span className="placeholder col-4"></span>
                        <span className="placeholder col-6"></span>
                    </p>
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default OPlaceholder;
